import '../sass/success-story.scss';

(() => {
    const $successStories = document.querySelectorAll('.success-story');

    if (!$successStories) return;

    $successStories.forEach($successStory => {
        const $carouselSmall = $successStory.querySelector('.success-story__related-carousel-small');
        const $carouselLarge = $successStory.querySelector('.success-story__related-carousel-large');

        const $navBtnPrev = $successStory.querySelector('.success-story__related-nav-btn--prev');
        const $navBtnNext = $successStory.querySelector('.success-story__related-nav-btn--next');

        const initCarousels = () => {
            let carouselSmall = null;
            let carouselLarge = null;

            if ($carouselSmall) {
                carouselSmall = new Swiper($carouselSmall);
            }

            if ($carouselLarge) {
                carouselLarge = new Swiper($carouselLarge, {
                    navigation: {
                        nextEl: $navBtnNext ?? null,
                        prevEl: $navBtnPrev ?? null,
                    },
                    rewind: true,
                });
            }
        };

        initCarousels();
    });
})();
